module.exports = __webpack_public_path__ + "img/freight_yard5_1.35cfbc52.png";